import styled, { css, keyframes } from 'styled-components';

export const RING_ENTER_MS = 550;

const pulseDiskInner = keyframes`
    0%, 100% { transform: scale(1); }
    50%      { transform: scale(1.05); }
`;

const pulseDiskMiddle = keyframes`
    0%, 100% { transform: scale(1); }
    50%      { transform: scale(1.07); }
`;

const pulseDiskOuter = keyframes`
    0%, 100% { transform: scale(1); }
    50%      { transform: scale(1.10); }
`;

const contractDisk = keyframes`
    0%   { transform: scale(1);    opacity: 1; }
    100% { transform: scale(0.9);  opacity: 0; }
`;

const DiskBase = css`
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    opacity: 0;
    transition: opacity ${RING_ENTER_MS}ms ease-out;
`;

export const DiskInner = styled.div`
    ${DiskBase}
    inset: -3px;
    background: var(--pulse-animation-color);
`;

export const DiskMiddle = styled.div`
    ${DiskBase}
    inset: -11px;
    background: color-mix(in srgb, var(--pulse-animation-color) 33%, transparent);
`;

export const DiskOuter = styled.div`
    ${DiskBase}
    inset: -22px;
    background: color-mix(in srgb, var(--pulse-animation-color) 18%, transparent);
`;

const speakingActive = css`
    &.active ${DiskInner} {
        will-change: transform, opacity;
        opacity: 1;
        animation: ${pulseDiskInner} 1.1s ease-in-out ${RING_ENTER_MS}ms infinite;
    }
    &.active ${DiskMiddle} {
        will-change: transform, opacity;
        opacity: 1;
        animation: ${pulseDiskMiddle} 1.3s ease-in-out ${RING_ENTER_MS}ms infinite;
    }
    &.active ${DiskOuter} {
        will-change: transform, opacity;
        opacity: 1;
        animation: ${pulseDiskOuter} 1.45s ease-in-out ${RING_ENTER_MS}ms infinite;
    }
`;

const speakingContracting = css`
    &.contracting ${DiskInner}, &.contracting ${DiskMiddle}, &.contracting ${DiskOuter} {
        will-change: transform, opacity;
        animation: ${contractDisk} ${RING_ENTER_MS}ms ease-out forwards;
    }
`;

export const AnimationWrapper = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;

    --pulse-animation-color: ${(props) => props.theme.root.colors.primary.default};

    ${speakingActive};
    ${speakingContracting};
`;
